// Identité visuelle de l'huilerie — MOCKED (localStorage), prête pour Supabase.
const KEY = 'oliva.branding';

export const BRANDING_DEFAUT = {
  nom: 'Huilerie Hassan Ellouze',
  slogan: 'Trituration & conditionnement d’huile d’olive',
  adresse: 'Route de Gabès Km 4, Zone industrielle — 3003 Sfax, Tunisie',
  tel: '+216 74 220 118',
  tel2: '+216 98 445 210',
  email: 'contact@huilerie-hassanellouze.tn',
  mf: '1284567/A/M/000',
  logo: '/logo-ellouze.png',
  loginLogo: '/logo-ellouze.png',
  loginFond:
    'https://images.pexels.com/photos/28752000/pexels-photo-28752000.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
  banniere:
    'https://images.pexels.com/photos/28704676/pexels-photo-28704676.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940',
};

export function getBranding() {
  const raw = localStorage.getItem(KEY);
  const stocke = raw ? JSON.parse(raw) : null;
  if (stocke?.nom === 'Huilerie Es-Sahel') delete stocke.nom;
  if (stocke?.email === 'contact@huilerie-essahel.tn') delete stocke.email;
  if (stocke?.logo?.includes('static.prod-images.emergentagent.com')) delete stocke.logo;
  if (stocke?.loginLogo?.includes('static.prod-images.emergentagent.com') || stocke?.loginLogo === '')
    delete stocke.loginLogo;
  return stocke ? { ...BRANDING_DEFAUT, ...stocke } : BRANDING_DEFAUT;
}

export function setBranding(patch) {
  const next = { ...getBranding(), ...patch };
  localStorage.setItem(KEY, JSON.stringify(next));
  window.dispatchEvent(new Event('branding-maj'));
  return next;
}
